import { render, staticRenderFns } from "./IconGeoloc.vue?vue&type=template&id=d140b7be&"
import script from "./IconGeoloc.vue?vue&type=script&lang=js&"
export * from "./IconGeoloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports